<template>
  <div class="form-page form-banks__wrap">
    <div class="tooltip">
      <span class="icon icon-info-line"><info-icon/></span>
      <p class="tooltip-text" v-html="history[currentStep].field.tooltip">
      </p>
    </div>
    <div v-for="(value, index) in offersCutted"
      :key="index"
      @click="selectOffer(getOfferId(value.link))"
      :class="{active: selectedOffers.includes(getOfferId(value.link))}"
      class="form-banks__item">
      <div class="form-banks__item-checked">
        <img src="https://cdn.crezu.net/game_flow/src/assets/img/banks-checked.svg" alt="">
      </div>
      <img :src="value.img" alt="">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'
import Crezu from '@/utils/'

export default {
  name: 'LenderPicker',
  components: { InfoIcon },
  data () {
    return {
      inputVal: null
    }
  },
  computed: {
    isValid () {
      let regex = new RegExp(this.history[this.currentStep].field.reg)
      return regex.test(this.inputVal)
    },
    offersCutted () {
      return this.offers.slice(0, 9)
    },
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      config: state => state.config,
      offers: state => state.offers,
      selectedOffers: state => state.selectedOffers
    })
  },
  mounted () {
    this.inputVal = this.history[this.currentStep].value
    this.$store.dispatch('pushGAEvent', 'lenderPickerInited')
  },
  watch: {
    inputVal: function (val) {
      if (!this.initValue) { this.initValue = true; return }
      this.$store.commit('UPDATE_FIELD', { isValid: this.isValid, val: val })
    }
  },
  methods: {
    selectOffer (id) {
      let temp = this.selectedOffers
      if (temp.indexOf(id) > -1) {
        temp.splice(temp.indexOf(id), 1)
      } else {
        temp.push(id)
      }
      this.$store.commit('CHANGE_SELECTED_OFFERS', temp)
    },
    getOfferId (link) {
      return Crezu.common.getURLParameter('offer_id', link)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/fields/LenderPicker.vue